import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Paper,
    Typography,
    Grid,
    Avatar
} from '@material-ui/core'
import { getContent } from '../../utils/helper'
import { ThankYouImage } from '../../assets/images/index'

class Thankyou extends Component {
    render() {
        const { languageJSON, requestState, location } = this.props;
        return (
            <Grid container justify="center" alignItems="center" style={{ backgroundColor: '#f2f9ff', height: '100vh' }}>
                <Grid item xs={10}>
                    <Paper style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '10%' }}>
                        <Typography variant="h4" style={{ marginBottom: '5%' }}>
                            {getContent(languageJSON, 'text_thankyou')}
                        </Typography>
                        <Avatar variant="square" style={{ width: 140, height: 192 }} src={ThankYouImage} />
                        <Typography variant="body1" style={{ paddingTop: '10%', textAlign: 'center' }}>
                            {location && location.params && location && location.params.key ? getContent(languageJSON, location.params.key) : getContent(languageJSON, 'text_process_complete_note', requestState.requestParams || {})}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = ({ language: { languageJSON }, shared: { requestState } }) => ({
    languageJSON,
    requestState
})

export default connect(mapStateToProps, null)(Thankyou)